<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        mounted()  {
        }
    }
</script>

<style>
    .el-button + .el-button {
        margin-left: 0 !important;
    }
    body {
        margin: 0;
        background: #f1f1f1;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        margin-top: 60px;
    }

    .second-header-wrap {
        background-color: unset !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue